import React from 'react';
import './companyStrength.css';

const CompanyStrength = () => {
    const promises = [
        {
            number: '01',
            title: '축적된 경험과 전문성',
            description: '20년 이상 축적된 현장 경험과 전문 기술을 바탕으로 안정적인 서비스를 제공합니다.'
        },
        {
            number: '02',
            title: '차별화된 기술력',
            description: '전문 기술력과 최적의 장비 구성을 통해 고객의 행사가 성공적으로 진행될 수 있도록 지원합니다.'
        },
        {
            number: '03',
            title: '고객 중심의 서비스',
            description: '다양한 현장 경험을 바탕으로 고객의 요구사항을 세심하게 반영하여 최상의 서비스를 제공합니다.'
        },
        {
            number: '04',
            title: '철저한 서비스 관리',
            description: '체계적인 서비스 교육과 책임감 있는 현장 대응으로 처음부터 끝까지 믿을 수 있는 서비스를 제공합니다.'
        }
    ];

    return (
        <div className="strength-section">
            <div className="strength-overlay"></div>
            <div className="strength-inner">
                <div className="strength-title">
                    <p>OUR PROMISE</p>
                    <h2>
                        고객을 향한<br />
                        <strong>엠티미디어의 약속</strong>
                    </h2>
                </div>

                <div className="strength-promises">
                    {promises.map((promise) => (
                        <div className="strength-promise" key={promise.number}>
                            <span className="promise-number">{promise.number}</span>
                            <h3>{promise.title}</h3>
                            <p>{promise.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CompanyStrength;